import { BrowserRouter } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import "./utils/arrayExtensions";
import AuthInitializer from "./AuthInitializer";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <AuthInitializer />
  </BrowserRouter>,
);

reportWebVitals();
